module.exports = __webpack_public_path__ + "images/frontpage_eye@2x.png?55a6c5e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_eye@2x.png
// module id = 640
// module chunks = 7